// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { CommercialAgreement } from '@daml.js/utility-commercials-v0/lib/Utility/Commercials/V0/Model/CommercialAgreement';
import {
  ERR_UPDATE_COMMERCIAL_AGREEMENT_CONSENT,
  SUC_UPDATE_COMMERCIAL_AGREEMENT_CONSENT,
} from '../../../utils/strings';
import { useExerciseSubmission } from '../ledger/useSubmission';

export const useModifyCommercialAgreementDataPublishingConsent = () => {
  const { submit } = useExerciseSubmission(
    CommercialAgreement.CommercialAgreement_ModifyDataPublishingConsent,
    SUC_UPDATE_COMMERCIAL_AGREEMENT_CONSENT,
    ERR_UPDATE_COMMERCIAL_AGREEMENT_CONSENT,
  );
  return submit;
};
